import { Col, SelectField } from '@/components';
import { PublishedLabelModifier } from '@/features/project/projects/_models/project-filter';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import { booleanStringType } from '@/utils/schemas';
import { isPS } from '@/utils/system';
import { type FC, memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const IsPublishedColField: FC = memo(() => {
  const { t } = useTranslation();

  const {
    control,
    formState: { errors },
  } = useFormContext<ProjectSearchFormType>();

  if (isPS()) {
    return null;
  }

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="isPublished"
        label={t('publish-ability')}
        control={control}
        errors={errors}
        options={booleanStringType.options.map((value) => ({
          value,
          label: PublishedLabelModifier[value],
        }))}
      />
    </Col>
  );
});
